import {
    FETCH_HELP,
    FETCH_HELP_SUCCESS,
    FETCH_HELP_FAIL
} from './actionTypes';

export const fetchHelp = () => ({
    type: FETCH_HELP
});

export const fetchHelpSuccess = response => ({
    type: FETCH_HELP_SUCCESS,
    payload: response
});

export const fetchHelpFail = error => ({
    type: FETCH_HELP_FAIL,
    payload: error
});
